import { render, staticRenderFns } from "./motoristas.vue?vue&type=template&id=e3352948&scoped=true"
import script from "./motoristas.vue?vue&type=script&lang=js"
export * from "./motoristas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3352948",
  null
  
)

export default component.exports